import { AutomationEventTypes } from "../AutomationModuleTypes";
import AutomationCommon from "../common";

const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

class MessageModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        const messagePickedEvent = this.messagePicked();
        return messagePickedEvent;
    }

    messagePicked() {
        const e = AutomationEventTypes.MESSAGE.MESSAGE_PICKED;
        const context = contexts.EVENT;

        return [
            ga(context, `event.${e}`, "Message Picked", vt.OBJECT, undefined, [
                ga(context, `event.${e}.$..*`, "*", vt.OBJECT),
                ga(context, `event.${e}.message`, "Picked Message", vt.OBJECT, undefined, [
                    ga(context, `event.${e}.message.$..*`, "*", vt.OBJECT),
                    ga(context, `event.${e}.message._id`, "Message ID", vt.STRING),
                    ga(context, `event.${e}.message.body`, "Message Body", vt.STRING),
                    ga(context, `event.${e}.message.type`, "Message Type", vt.STRING),
                    ga(context, `event.${e}.message.direction`, "Message Direction", vt.STRING),
                    ga(context, `event.${e}.message.status`, "Message Status", vt.STRING),
                    ga(context, `event.${e}.message.createdAt`, "Created At", vt.DATE),
                    ga(context, `event.${e}.message.updatedAt`, "Updated At", vt.DATE),
                    ga(
                        context,
                        `event.${e}.message.conversation`,
                        "Conversation",
                        vt.OBJECT,
                        undefined,
                        this.parent.generateConversationAttributes(`event.${e}.message.conversation`, false)
                    ),
                    ga(
                        context,
                        `event.${e}.message.contact`,
                        "Contact",
                        vt.OBJECT,
                        undefined,
                        this.parent.generateContactAttributes(`event.${e}.message.contact`)
                    ),
                    ga(context, `event.${e}.message.user`, "User", vt.OBJECT, undefined, [
                        ga(context, `event.${e}.message.user._id`, "User ID", vt.STRING),
                        ga(context, `event.${e}.message.user.name`, "User Name", vt.STRING),
                        ga(context, `event.${e}.message.user.email`, "User Email", vt.STRING),
                    ]),
                    ga(context, `event.${e}.message.asset`, "Asset", vt.OBJECT, undefined, [
                        ga(context, `event.${e}.message.asset._id`, "Asset ID", vt.STRING),
                        ga(context, `event.${e}.message.asset.name`, "Asset Name", vt.STRING),
                        ga(context, `event.${e}.message.asset.path`, "Asset Path", vt.STRING),
                        ga(context, `event.${e}.message.asset.mime`, "Asset MIME Type", vt.STRING),
                        ga(context, `event.${e}.message.asset.ext`, "Asset Extension", vt.STRING),
                        ga(context, `event.${e}.message.asset.platform`, "Asset Platform", vt.STRING),
                        ga(context, `event.${e}.message.asset.size`, "Asset Size", vt.NUMBER),
                        ga(context, `event.${e}.message.asset.type`, "Asset Type", vt.STRING),
                        ga(context, `event.${e}.message.asset.refUserId`, "Asset Ref User ID", vt.STRING),
                        ga(context, `event.${e}.message.asset.payload`, "Asset Payload", vt.OBJECT),
                        ga(context, `event.${e}.message.asset.cdnUrl`, "Asset CDN URL", vt.STRING),
                        ga(context, `event.${e}.message.asset.s3Url`, "Asset S3 URL", vt.STRING),
                        ga(context, `event.${e}.message.asset.createdAt`, "Asset Created At", vt.DATE),
                        ga(context, `event.${e}.message.asset.updatedAt`, "Asset Updated At", vt.DATE),
                    ]),
                    ga(context, `event.${e}.message.mail`, "Mail", vt.OBJECT, undefined, [
                        ga(context, `event.${e}.message.mail._id`, "Mail ID", vt.STRING),
                        ga(context, `event.${e}.message.mail.subject`, "Mail Subject", vt.STRING),
                        ga(context, `event.${e}.message.mail.body`, "Mail Body", vt.STRING),
                    ]),
                    ga(context, `event.${e}.message.replyTo`, "Reply To", vt.OBJECT, undefined, [
                        ga(context, `event.${e}.message.replyTo._id`, "Reply To Message ID", vt.STRING),
                    ]),
                    ga(context, `event.${e}.message.payload`, "Payload", vt.OBJECT),
                    ga(context, `event.${e}.message.location`, "Location", vt.OBJECT),
                ]),
                ga(context, `event.${e}.zohoRecordId`, "Zoho Record ID", vt.STRING),
                ga(context, `event.${e}.zohoModule`, "Zoho Module", vt.STRING),
            ]),
        ];
    }
}

export default MessageModuleAttributeFactory;
